Wee.fn.make('news', {
	init: function() {
		$('ref:newsFilter').on('change.news', function(e, el) {
			Wee.formFilter.filter({
				form: 'ref:filterForm',
				el: $(el),
				path: '/news'
			});
		});
	},
	unload: function() {
		$.events.off(null, '.news');
	}
});
